import { document, window } from '../../../../../helpers/BrowserHelpers';
export default function getCurrentSelectionRect(editor) {
  if (editor.value.selection.isSet) {
    try {
      var _range = editor.findDOMRange(editor.value.selection, window);

      if (_range) return _range.getBoundingClientRect();
    } catch (_unused) {
      console.debug('Selection not found, falling back on native selection');
    }
  }

  var selection = document.getSelection();
  if (!selection || selection.rangeCount <= 0) return;
  var range = selection.getRangeAt(0);
  if (!range) return;
  return range.getBoundingClientRect();
}